import {linear} from "svelte/easing";

// Slides in/out horizontally from the left hand side of the containing element
export const slideXLeft = (node, params) => {
    return {
        delay: params.delay || 0,
        duration: params.delay || 500,
        easing: params.easing || linear,
        css: (t, u) => `transform: translateX(${t * 100}%)`
    };
};

// Slides in/out horizontally from the right hand side of the containing element
export const slideXRight = (node, params) => {
    return {
        delay: params.delay || 0,
        duration: params.delay || 500,
        easing: params.easing || linear,
        css: (t, u) => `transform: translateX(${u * 100}%)`
    };
};

export const fadeScale = (node, { delay = 0, duration = 200, easing = x => x, base_scale = 0 }) => {
    const o = +getComputedStyle(node).opacity;
    const m = getComputedStyle(node).transform.match(/scale\(([0-9.]+)\)/);
    const s = m ? m[1] : 1;
    const is = 1 - base_scale;

    return {
        delay,
        duration,
        css: t => {
            const eased = easing(t);
            return `opacity: ${eased * o}; transform: scale(${(eased * s * is) + base_scale})`;
        }
    };
}
